<template>
    <div>

        <h2 class="title is-marginless">Resale Certificates</h2>

        <div class="certs">
            <loading v-if="loading"></loading>
            <div v-else-if="!certificates.length" class="message is-warning">
                <div class="message-body">
                    You have not added any resale certificates yet
                </div>
            </div>
            <div
                v-for="cert in certificates"
                :key="cert.id"
                class="flex-con sm-pad-lr is-grow cert"
            >
                <div class="is-narrow">
                    <div class="tag is-large is-dark">
                        {{cert.state}}
                    </div>
                </div>
                <div>
                    <h6 class="heading is-size-6 is-marginless">{{cert.number}}</h6>
                    <div>
                        Expires : <timestamp :value="cert.expiresAt"/>
                    </div>
                    <div v-if="cert.file && cert.file.url">
                        <a :href="cert.file.url" target="_blank">
                            View Uploaded Certificate
                        </a>
                    </div>
                </div>
                <div class="is-narrow">
                    <div class="button is-danger is-small" @click="confirmRemoveCertificate(cert)">
                        <span class="icon">
                            <i class="fa fa-trash"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="button is-primary" @click="modal.open()">
            Add Resale Cert
        </div>

        <confirm-modal
            :active="removeModal.active"
            :callback="removeCertificate"
            :loading="loadingRemove"
            :close="() => { removeModal.active = false}"
        >
            <div class="has-text-centered">
                <h2 class="is-size-4">Are you sure you want to remove this resale certificate?</h2>
            </div>
        </confirm-modal>

        <modal
            :active="modal.active"
            :close="modal.close"
            is-card
        >
            <template #header>
                <h6 class="heading is-size-6 m-n">
                    Add Resale Certificate
                </h6>
            </template>
            <template #default>
                <div class="field">
                    <label class="label">Resale Certificate Number</label>
                    <input
                        v-model="modal.data.number"
                        v-validate="'required'"
                        class="input"
                        :class="{ 'is-danger' : errors.has('number') }"
                        name="number"
                    />
                </div>
                <div class="field">
                    <label class="label">State</label>
                    <div class="select">
                        <state-dropdown
                            v-model="modal.data.state"
                            v-validate="'required'"
                            :class="{ 'is-danger' : errors.has('state') }"
                            name="state"
                        />
                    </div>
                </div>
                <div class="field">
                    <label class="label">Expiration Date</label>
                    <date-picker
                        v-model="modal.data.expiresAt"
                        v-validate="'required'"
                        required
                        name="expiresAt"
                        label="Expiration Date"
                    />
                </div>

                <div
                    class=""
                >
                    <label class="label">Resale Certificate File <small>(image or PDF)</small></label>
                    <div v-if="!uploadFiles.file" class="file">
                        <label class="file-label">
                            <input
                                class="file-input"
                                type="file"
                                name="file"
                                accept=".png,.jpeg,.jpg,.pdf"
                                v-validate="{ 'required' : $store.state.dealer_portal.settings.upload_resale_certificates }"
                                @change="addFile($event.target.files)"
                            >
                            <span class="file-cta">
                                <span class="file-icon">
                                    <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label">
                                    Upload Certificate
                                </span>
                            </span>
                        </label>
                    </div>
                    <div v-else class="flex-con xs-pad-lr">
                        <div>
                            <div class="button is-danger" @click="clearFiles">
                                <span class="icon">
                                    <i class="fa fa-remove"></i>
                                </span>
                            </div>
                        </div>
                        <div>
                            {{uploadFiles.file.name}}
                        </div>
                    </div>
                    <div class="has-text-danger" v-if="errors.has('file')">
                        You must select a file to upload
                    </div>
                </div>

            </template>
            <template #footer>
                <div class="has-text-right">
                    <loading-button
                        class="is-primary"
                        :loading="loadingAdd"
                        @click="addCertificate"
                    >
                        Add
                    </loading-button>
                </div>
            </template>
        </modal>

    </div>
</template>

<script>
import StateDropdown from "../../../elements/StateDropdown";
import DatePicker from "../../../elements/DatePicker";
import ResaleCertificateApi from "../../../api/ResaleCertificateApi";
const defaultFields = () => {
    return {
        number : null,
        state : null,
        expiresAt : null,
    };
};
export default {
    components : {DatePicker, StateDropdown},
    data () {
        return {
            loading : true,
            certificates : [],
            loadingAdd : false,
            loadingRemove : false,
            uploadFiles : {
                formData : null,
                file : null,
            },
            modal : {
                active : false,
                open : () => {
                    this.modal.active = true;
                },
                close : () => {
                    this.modal.active = false;
                },
                data : defaultFields(),
            },
            removeModal : {
                active : false,
                certificate : null,
            },

        }
    },
    beforeMount () {
        ResaleCertificateApi.getResaleCertificates().then(res => {
            this.certificates = res.data;
            this.loading = false;
        });
    },
    methods : {
        addFile (files) {

            if(files.length !== 1) {
                return;
            }

            this.uploadFiles.file = files[0];

            const formData = new FormData();

            formData.set('name', this.handle);

            Array
                .from(Array(files.length).keys())
                .forEach(x => {
                    formData.append('file', files[x], files[x].name);
                });

            this.uploadFiles.formData = formData;

        },

        clearFiles () {
            this.uploadFiles.formData = null;
            this.uploadFiles.file = null;
        },

        addCertificate () {
            this.$validator.validateAll().then(valid => {
                if(!valid) {
                    this.$notifyError('Please fix the errors listed in red and try again');
                    return;
                }

                if(this.certificates.find(c => c.state === this.modal.data.state)) {
                    this.$notifyError(`You already provided a certificate for ${this.modal.data.state}, please remove the existing one before adding another`);
                    return;
                }

                this.loadingAdd = true;

                ResaleCertificateApi.postResaleCertificate(this.uploadFiles.formData, this.modal.data).then(res => {
                    this.clearFiles();
                    this.modal.data = defaultFields();
                    this.certificates.push(res.data);
                    this.modal.active = false;
                    this.$notifySuccess('Resale certificate added');
                }).finally(() => {
                    this.loadingAdd = false;
                });

            });
        },

        confirmRemoveCertificate (cert) {
            this.removeModal.certificate = cert;
            this.removeModal.active = true;
        },

        removeCertificate (yes) {
            if(!yes) {
                this.removeModal.active = false;
                return;
            }

            this.loadingRemove = true;

            ResaleCertificateApi.deleteResaleCertificate(this.removeModal.certificate.id).then(() => {
                this.certificates = this.certificates.filter(c => c.id !== this.removeModal.certificate.id);
                this.removeModal.active = false;
            }).finally(() => {
                this.loadingRemove = false;
            })

        },

    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';
    .certs {
        margin:20px 0;
    }
    .cert {
        background-color:$white-ter;
        padding:10px;
        margin-bottom:10px;
        border-radius:5px;
    }
</style>
